import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Table, Button, Form, Row, Col, Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import { LOPHUONGDANTHUCHANH_TRIENKHAI_HV_API } from '../../../utils/apiUrl';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { Get } from '../../../utils/httpProvider';
import { getUserSub } from '../../../utils/helper';
import {
    objectShowNumber,
    trangThaiDotTuyenSinhValue,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../utils/define';

const LopHuongDanThucHanhHV = () => {
    const history = useHistory();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const fetchUserId = async () => {
            const sub = await getUserSub();
            setUserId(sub);
        };
        fetchUserId();
    }, []);

    const filterPayload = {
        pageIndex: page,
        pageSize: pageSize,
        keyword: valueSearch || '',
        hocVienAccountId: userId || ''
    };

    const { data: pagedData, isLoading } = useQuery(
        ['lopHuongDanThucHanhHVPaging', page, pageSize, valueSearch, userId],
        () => Get(LOPHUONGDANTHUCHANH_TRIENKHAI_HV_API.GET_PAGING, null, filterPayload),
        { 
            enabled: !!userId,
            keepPreviousData: true 
        }
    );

    const listLop = pagedData?.data?.$values || pagedData?.data || [];
    const totalRecords = pagedData?.totalRecords || 0;

    const getTrangThaiBadge = (st) => {
        switch (st) {
            case trangThaiDotTuyenSinhValue.sapMo: return <Badge variant="secondary">Sắp mở</Badge>;
            case trangThaiDotTuyenSinhValue.dangMo: return <Badge variant="success">Đang mở</Badge>;
            case trangThaiDotTuyenSinhValue.daDong: return <Badge variant="dark">Đã đóng</Badge>;
            case trangThaiDotTuyenSinhValue.tamDung: return <Badge variant="warning">Tạm dừng</Badge>;
            default: return <Badge variant="light">Mới tạo</Badge>;
        }
    };

    return (
        <div className="p-3">
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-white py-3">
                    <Row className="align-items-center justify-content-between">
                        <Col md={6}>
                            <h5 className="mb-0 text-info font-weight-bold">
                                <i className="fas fa-user-graduate mr-2"></i>
                                Lớp Hướng Dẫn Thực Hành Của Tôi (Học Viên)
                            </h5>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table striped bordered hover className="mb-0 align-middle">
                            <thead className="thead-light text-nowrap">
                                <tr>
                                    <th style={{ width: 50 }} className="text-center">#</th>
                                    <th style={{ minWidth: 280 }}>Tên khóa học / Lớp</th>
                                    <th style={{ minWidth: 130 }} className="text-center">Số quyết định</th>
                                    <th style={{ minWidth: 120 }} className="text-center">Ngày khai giảng</th>
                                    <th style={{ minWidth: 120 }} className="text-center">Ngày bế giảng</th>
                                    <th style={{ minWidth: 100 }} className="text-center">Số lượng HV</th>
                                    <th style={{ minWidth: 110 }} className="text-right">Học phí</th>
                                    <th style={{ minWidth: 110 }} className="text-center">Trạng thái</th>
                                    <th className="text-center" style={{ width: 130 }}>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading || !userId ? (
                                    <tr><td colSpan={9} className="text-center py-4">Đang tải danh sách lớp học...</td></tr>
                                ) : listLop.length === 0 ? (
                                    <tr><td colSpan={9} className="text-center py-4 text-muted">Không tìm thấy lớp học nào bạn tham gia học tập.</td></tr>
                                ) : (
                                    listLop.map((lop, idx) => (
                                        <tr key={lop.id}>
                                            <td className="text-center">{(page - 1) * pageSize + idx + 1}</td>
                                            <td className="font-weight-bold" style={{ whiteSpace: 'normal', minWidth: 280 }}>
                                                <a
                                                    href={`#${URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_HV_PATH}/${lop.id}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        history.push(`${URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_HV_PATH}/${lop.id}`);
                                                    }}
                                                    className="text-info"
                                                >
                                                    {lop.tenKhoaHoc}
                                                </a>
                                            </td>
                                            <td className="text-center">{lop.soQuyetDinh || "—"}</td>
                                            <td className="text-center">{lop.ngayKhaiGiang ? moment(lop.ngayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : "—"}</td>
                                            <td className="text-center">{lop.ngayBeGiang ? moment(lop.ngayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : "—"}</td>
                                            <td className="text-center">
                                                <Badge variant="info">
                                                    {lop.soLuongHocVienThucTe || 0} HV
                                                </Badge>
                                            </td>
                                            <td className="text-right font-weight-bold">
                                                {lop.hocPhi ? lop.hocPhi.toLocaleString('vi-VN') + " đ" : "Miễn phí"}
                                            </td>
                                            <td className="text-center">{getTrangThaiBadge(lop.trangThaiDotTuyenSinh)}</td>
                                            <td className="text-center">
                                                <Button
                                                    variant="info"
                                                    size="sm"
                                                    onClick={() => history.push(`${URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_HV_PATH}/${lop.id}`)}
                                                >
                                                    <i className="fas fa-arrow-right mr-1"></i> Vào lớp
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
                {totalRecords > 0 && (
                    <Card.Footer className="bg-white border-0 py-3">
                        <Row className="align-items-center">
                            <Col md={4} className="d-flex align-items-center mb-2 mb-md-0">
                                <span className="text-muted mr-2">Hiển thị:</span>
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    style={{ width: 80 }}
                                    value={pageSize}
                                    onChange={(e) => {
                                        setPageSize(Number(e.target.value));
                                        setPage(1);
                                    }}
                                >
                                    {objectShowNumber.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </Form.Control>
                                <span className="text-muted ml-2">/ tổng số {totalRecords} lớp</span>
                            </Col>
                            <Col md={8} className="d-flex justify-content-md-end justify-content-center">
                                <Pagination
                                    activePage={page}
                                    itemsCountPerPage={pageSize}
                                    totalItemsCount={totalRecords}
                                    pageRangeDisplayed={5}
                                    onChange={(pageNumber) => setPage(pageNumber)}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </Col>
                        </Row>
                    </Card.Footer>
                )}
            </Card>
        </div>
    );
};

export default LopHuongDanThucHanhHV;
